const ACCESS = {
   "ARCHIVOS_DE_CLIENTE": {
      "SUBIR_ARCHIVO": 240000
   },
   "ASIGNACION_TRANSPORTISTA": {
      "VER_TODAS_ASIGNACIONES": 4000,
      "VER_ASIGNACIONES_SUCURSAL_DEL_USUARIO": 4001,
      "VER_ASIGNACIONES_CREADAS_POR_EL_USUARIO": 4002,
      "EDITAR_TODAS_ASIGNACIONES": 4003,
      "EDITAR_ASIGNACIONES_SUCURSAL_DEL_USUARIO": 4004,
      "EDITAR_ASIGNACIONES_CREADAS_POR_EL_USUARIO": 4005,
      "AGREGAR_GUIAS_A_ASIGNACION": 4006,
      "MARCAR_SALIDA_A_TODOS_LAS_ASIGNACIONES": 4007,
      "MARCAR_SALIDA_A_ASIGNACIONES_CREADAS_POR_EL_USUARIO": 4008,
      "MARCAR_SALIDA_A_ASIGNACIONES_DE_SUCURSAL_DEL_USUARIO": 4009,
      "GENERAR_CARTA_PORTE": 4010,
      "CREAR_ASIGNACION_TRANSPORTISTA": 4011,
      "EDITAR_SIN_RESTRICCIONES": 4012,
   },
   "CATALOGO_BANCOS": {
      "VER_CATALOGO": 260000,
      "CREAR_CATALOGO": 260001,
      "EDITAR_CATALOGO": 260002,
      "ELIMINAR_CATALOGO": 260003
   },
   "CATALOGO_CAMIONES": {
      "VER_CATALOGO": 270000,
      "CREAR_CATALOGO": 270001,
      "EDITAR_CATALOGO": 270002,
      "ELIMINAR_CATALOGO": 270003
   },
   "CATALOGO_CARGOS_CREDITOS": {
      "VER_CATALOGO": 290000,
      "CREAR_CATALOGO": 290001,
      "EDITAR_CATALOGO": 290002,
      "ELIMINAR_CATALOGO": 290003
   },
   "CATALOGO_CHOFERES": {
      "VER_CATALOGO": 300000,
      "CREAR_CATALOGO": 300001,
      "EDITAR_CATALOGO": 300002,
      "ELIMINAR_CATALOGO": 300003
   },
   "CATALOGO_CIRCUITOS": {
      "VER_CATALOGO": 310000,
      "CREAR_CATALOGO": 310001,
      "EDITAR_CATALOGO": 310002,
      "ELIMINAR_CATALOGO": 310003
   },
   "CATALOGO_CLIENTES": {
      "VER_CATALOGO": 330000,
      "CREAR_CATALOGO": 330001,
      "EDITAR_CATALOGO": 330002,
      "ELIMINAR_CATALOGO": 330003,
      "VER_SOLO_CREDITO": 330052,
      "VER_SOLO_CONTADO": 330053,
      "CREAR_SOLO_CREDITO": 330054,
      "CREAR_SOLO_CONTADO": 330055,
   },
   "CATALOGO_CLIENTES_ADMINISTRATIVO": {
      "VER_CATALOGO": 330020,
      "EDITAR_CATALOGO": 330021
   },
   "CATALOGO_CLIENTES_API": {
      "VER_CATALOGO": 330050,
      "EDITAR_CATALOGO": 330051
   },
   "CATALOGO_CLIENTES_CFDI": {
      "VER_CATALOGO": 330029,
      "EDITAR_CATALOGO": 330030
   },
   "CATALOGO_CLIENTES_CONVENIO": {
      "VER_CATALOGO": 330032,
      "EDITAR_CATALOGO": 330033
   },
   "CATALOGO_CLIENTES_DESTINATARIO": {
      "VER_CATALOGO": 330009,
      "CREAR_CATALOGO": 330010,
      "EDITAR_CATALOGO": 330011,
      "ELIMINAR_CATALOGO": 330012
   },
   "CATALOGO_CLIENTES_ESTADISTICO": {
      "VER_CATALOGO": 330023,
      "EDITAR_CATALOGO": 330024
   },
   "CATALOGO_CLIENTES_FACTORAJE": {
      "VER_CATALOGO": 330047,
      "EDITAR_CATALOGO": 330048
   },
   "CATALOGO_CLIENTES_FOLIO": {
      "VER_CATALOGO": 330041,
      "EDITAR_CATALOGO": 330042
   },
   "CATALOGO_CLIENTES_GRUPO": {
      "VER_CATALOGO": 330014,
      "EDITAR_CATALOGO": 330015
   },
   "CATALOGO_CLIENTES_PAGO": {
      "VER_CATALOGO": 330038,
      "EDITAR_CATALOGO": 330039
   },
   "CATALOGO_CLIENTES_PAGO_TRANSPORTISTA": {
      "VER_CATALOGO": 330044,
      "EDITAR_CATALOGO": 330045
   },
   "CATALOGO_CLIENTES_PRECIO": {
      "VER_CATALOGO": 330035,
      "EDITAR_CATALOGO": 330036
   },
   "CATALOGO_CLIENTES_REMITENTE": {
      "VER_CATALOGO": 330005,
      "CREAR_CATALOGO": 330006,
      "EDITAR_CATALOGO": 330007,
      "ELIMINAR_CATALOGO": 330008
   },
   "CATALOGO_CLIENTES_REP_LEGAL": {
      "VER_CATALOGO": 330026,
      "EDITAR_CATALOGO": 330027
   },
   "CATALOGO_CLIENTES_VENTA": {
      "VER_CATALOGO": 330017,
      "EDITAR_CATALOGO": 330018
   },
   "CATALOGO_COLONIAS": {
      "VER_CATALOGO": 340000,
      "CREAR_CATALOGO": 340001,
      "EDITAR_CATALOGO": 340002,
      "ELIMINAR_CATALOGO": 340003
   },
   "CATALOGO_CONCEPTOS_DE_REDOCUMENTACION": {
      "VER_CATALOGO": 350000,
      "CREAR_CATALOGO": 350001,
      "EDITAR_CATALOGO": 350002,
      "ELIMINAR_CATALOGO": 350003
   },
   "CATALOGO_CONDICIONES_DE_PAGO": {
      "VER_CATALOGO": 360000,
      "CREAR_CATALOGO": 360001,
      "EDITAR_CATALOGO": 360002,
      "ELIMINAR_CATALOGO": 360003
   },
   "CATALOGO_CPAC": {
      "VER_CATALOGO": 280000,
      "CREAR_CATALOGO": 280001,
      "EDITAR_CATALOGO": 280002,
      "ELIMINAR_CATALOGO": 280003
   },
   "CATALOGO_CUENTAS_BANCARIAS": {
      "VER_CATALOGO": 370000,
      "CREAR_CATALOGO": 370001,
      "EDITAR_CATALOGO": 370002,
      "ELIMINAR_CATALOGO": 370003
   },
   "CATALOGO_EJECUTIVOS": {
      "VER_CATALOGO": 380000,
      "CREAR_CATALOGO": 380001,
      "EDITAR_CATALOGO": 380002,
      "ELIMINAR_CATALOGO": 380003
   },
   "CATALOGO_EMBALAJES": {
      "VER_CATALOGO": 390000,
      "CREAR_CATALOGO": 390001,
      "EDITAR_CATALOGO": 390002,
      "ELIMINAR_CATALOGO": 390003
   },
   "CATALOGO_FALLAS_DE_DESEMBARQUE": {
      "VER_CATALOGO": 400000,
      "CREAR_CATALOGO": 400001,
      "EDITAR_CATALOGO": 400002,
      "ELIMINAR_CATALOGO": 400003
   },
   "CATALOGO_FORMAS_DE_PAGO": {
      "VER_CATALOGO": 410000,
      "CREAR_CATALOGO": 410001,
      "EDITAR_CATALOGO": 410002,
      "ELIMINAR_CATALOGO": 410003
   },
   "CATALOGO_GIROS": {
      "VER_CATALOGO": 420000,
      "CREAR_CATALOGO": 420001,
      "EDITAR_CATALOGO": 420002,
      "ELIMINAR_CATALOGO": 420003
   },
   "CATALOGO_GRUPOS_DE_EMBALAJE": {
      "VER_CATALOGO": 430000,
      "CREAR_CATALOGO": 430001,
      "EDITAR_CATALOGO": 430002,
      "ELIMINAR_CATALOGO": 430003
   },
   "CATALOGO_IMPUESTOS": {
      "VER_CATALOGO": 440000,
      "CREAR_CATALOGO": 440001,
      "EDITAR_CATALOGO": 440002,
      "ELIMINAR_CATALOGO": 440003
   },
   "CATALOGO_LINEAS_DE_TRANSPORTE": {
      "VER_CATALOGO": 450000,
      "CREAR_CATALOGO": 450001,
      "EDITAR_CATALOGO": 450002,
      "ELIMINAR_CATALOGO": 450003
   },
   "CATALOGO_LUGARES": {
      "VER_CATALOGO": 460000,
      "CREAR_CATALOGO": 460001,
      "EDITAR_CATALOGO": 460002,
      "ELIMINAR_CATALOGO": 460003
   },
   "CATALOGO_METODOS_DE_PAGO": {
      "VER_CATALOGO": 470000,
      "CREAR_CATALOGO": 470001,
      "EDITAR_CATALOGO": 470002,
      "ELIMINAR_CATALOGO": 470003
   },
   "CATALOGO_MOTIVO_DEPURACION": {
      "VER_CATALOGO": 480000,
      "CREAR_CATALOGO": 480001,
      "EDITAR_CATALOGO": 480002,
      "ELIMINAR_CATALOGO": 480003
   },
   "CATALOGO_MOTIVOS_ATRASO_EMBARQUE": {
      "VER_CATALOGO": 490000,
      "CREAR_CATALOGO": 490001,
      "EDITAR_CATALOGO": 490002,
      "ELIMINAR_CATALOGO": 490003
   },
   "CATALOGO_MOTIVOS_DE_ENTREGA_TARDE": {
      "VER_CATALOGO": 510000,
      "CREAR_CATALOGO": 510001,
      "EDITAR_CATALOGO": 510002,
      "ELIMINAR_CATALOGO": 510003
   },
   "CATALOGO_MOTIVOS_DE_RECHAZO": {
      "VER_CATALOGO": 500000,
      "CREAR_CATALOGO": 500001,
      "EDITAR_CATALOGO": 500002,
      "ELIMINAR_CATALOGO": 500003
   },
   "CATALOGO_ORIGENES": {
      "VER_CATALOGO": 520000,
      "CREAR_CATALOGO": 520001,
      "EDITAR_CATALOGO": 520002,
      "ELIMINAR_CATALOGO": 520003
   },
   "CATALOGO_REGIMENES_FISCALES_CFDI": {
      "VER_CATALOGO": 530000,
      "CREAR_CATALOGO": 530001,
      "EDITAR_CATALOGO": 530002,
      "ELIMINAR_CATALOGO": 530003
   },
   "CATALOGO_REMOLQUES": {
      "VER_CATALOGO": 560000,
      "CREAR_CATALOGO": 560001,
      "EDITAR_CATALOGO": 560002,
      "ELIMINAR_CATALOGO": 560003
   },
   "CATALOGO_RUTAS": {
      "VER_CATALOGO": 540000,
      "CREAR_CATALOGO": 540001,
      "EDITAR_CATALOGO": 540002,
      "ELIMINAR_CATALOGO": 540003
   },
   "CATALOGO_RUTAS_TRANSPORTISTA": {
      "VER_CATALOGO": 550000,
      "CREAR_CATALOGO": 550001,
      "EDITAR_CATALOGO": 550002,
      "ELIMINAR_CATALOGO": 550003
   },
   "CATALOGO_SUCURSALES": {
      "VER_CATALOGO": 570000,
      "CREAR_CATALOGO": 570001,
      "EDITAR_CATALOGO": 570002,
      "ELIMINAR_CATALOGO": 570003
   },
   "CATALOGO_TIPOS_DE_CARGOS_CREDITOS": {
      "VER_CATALOGO": 580000,
      "CREAR_CATALOGO": 580001,
      "EDITAR_CATALOGO": 580002,
      "ELIMINAR_CATALOGO": 580003
   },
   "CATALOGO_TIPOS_DE_LISTA_DE_PRECIOS": {
      "VER_CATALOGO": 590000,
      "CREAR_CATALOGO": 590001,
      "EDITAR_CATALOGO": 590002,
      "ELIMINAR_CATALOGO": 590003
   },
   "CATALOGO_TIPOS_SEGUIMIENTO_DE_GUIAS": {
      "VER_CATALOGO": 600000,
      "CREAR_CATALOGO": 600001,
      "EDITAR_CATALOGO": 600002,
      "ELIMINAR_CATALOGO": 600003
   },
   "CATALOGO_TRANSPORTISTAS": {
      "VER_CATALOGO": 610000,
      "CREAR_CATALOGO": 610001,
      "EDITAR_CATALOGO": 610002,
      "ELIMINAR_CATALOGO": 610003
   },
   "CATALOGO_UNIDADES_DE_MEDIDA_CFDI": {
      "VER_CATALOGO": 620000,
      "CREAR_CATALOGO": 620001,
      "EDITAR_CATALOGO": 620002,
      "ELIMINAR_CATALOGO": 620003
   },
   "CATALOGO_UNIDADES_DE_TRANSPORTE": {
      "VER_CATALOGO": 630000,
      "CREAR_CATALOGO": 630001,
      "EDITAR_CATALOGO": 630002,
      "ELIMINAR_CATALOGO": 630003,
      "GENERAR_CONTRASENA": 630004
   },
   "CATALOGO_USOS_CFDI": {
      "VER_CATALOGO": 640000,
      "CREAR_CATALOGO": 640001,
      "EDITAR_CATALOGO": 640002,
      "ELIMINAR_CATALOGO": 640003
   },
   "CATALOGO_ZONAS": {
      "VER_CATALOGO": 650000,
      "CREAR_CATALOGO": 650001,
      "EDITAR_CATALOGO": 650002,
      "ELIMINAR_CATALOGO": 650003
   },
   "CATALOGO_ZONAS_KM": {
      "VER_CATALOGO": 660000,
      "CREAR_CATALOGO": 660001,
      "EDITAR_CATALOGO": 660002,
      "ELIMINAR_CATALOGO": 660003
   },
   "CATALOGOS_PRECIO_COMBUSTIBLE": {
      "VER_CATALOGO": 250000,
      "CREAR_NUEVO": 250001,
      "EDITAR_CATALOGO": 250002
   },
   "COBRANZA_APLICACION_PAGOS": {
      "VER_CREDITO": 70000,
      "EDITAR_DEPOSITO_CREDITO": 70001,
      "TIMBRAR_DEPOSITO_CREDITO": 70002,
      "VER_CONTADO": 70003,
      "EDITAR_DEPOSITO_CONTADO": 70004,
      "TIMBRAR_DEPOSITO_CONTADO": 70005,
      "CANCELAR_DEPOSITO": 70006,
   },
   "COBRANZA_CONSECUTIVO_DE_FACTURAS": {
      "DESCARGAR_REPORTE": 220001
   },
   "COBRANZA_CONTRA_RECIBO": {
      "VER_TODOS_LOS_CONTRARECIBOS": 100000,
      "CREAR_CONTRARECIBO": 100001
   },
   "COBRANZA_CONTROL_DEPOSITO": {
      "VER_TODOS_LOS_DEPOSITOS": 40000,
      "VER_DEPOSITOS_CREADOS_POR_EL_USUARIO": 40001,
      "CREAR_DEPOSITO": 40002,
      "IDENTIFICAR_DEPOSITO": 40003,
      "ELIMINAR_DEPOSITO": 40004,
   },
   "COBRANZA_DESCARGA_DE_ARCHIVOS": {
      "DESCARGAR_FACTURA_CONTADO": 50000,
      "DESCARGAR_FACTURA_CREDITO": 50001,
      "DESCARGAR_NOTA_CREDITO": 50002
   },
   "COBRANZA_ENVIO_FACTURAS": {
      "VER_TODOS_LOS_FOLIOS": 60000,
      "VER_FOLIOS_SUCURSAL_USUARIO": 60001,
      "VER_FOLIOS_CREADOS_POR_USUARIO": 60002,
      "RECIBIR_FOLIO": 60003,
      "CREAR_FOLIO": 60004,
      "DESCARGAR_REPORTE": 60005
   },
   "COBRANZA_FACTURAS_POR_CLIENTE": {
      "VER_TODOS_LOS_FOLIOS": 230000,
      "VER_FOLIOS_CREADOS_POR_USUARIO": 230001,
      "CREAR_FOLIO": 230002,
      "MARCAR_RECIBIDO": 230003
   },
   "COBRANZA_GUIAS_PENDIENTES": {
      "DESCARGAR_REPORTE": 220000
   },
   "COBRANZA_GUIAS_RECIBIDAS": {
      "VER_TODAS_LOS_FOLIOS": 30000,
      "VER_FOLIOS_SUCURSAL_DEL_USUARIO": 30001,
      "REVISAR_FOLIO": 30002
   },
   "COBRANZA_NOTA_CREDITO": {
      "VER_TODAS_NOTAS_CREDITO": 90000,
      "VER_NOTAS_CREADAS_POR_EL_USUARIO": 90001,
      "CREAR_NOTA_DE_CREDITO": 90002,
      "TIMBRAR_NOTA_DE_CREDITO": 90003,
      "CANCELAR_NOTA_DE_CREDITO": 90004,
      "DESCARGAR_ARCHIVOS": 90005,
   },
   "COBRANZA_PAGO_TRANSPORTISTA": {
      "PAGO_RECOLECCION": 210000,
      "PAGO_ENTREGA": 210001,
      "VER_DETALLE_PAGO_TRANSPORTISTA": 210002,
      "MODIFICAR_PAGO_TRANSPORTISTA": 210003,
      "IMPRIMIR_PAGO_TRANSPORTISTA": 210004
   },
   "COBRANZA_POLIZA_CONTABLE": {
      "DESCARGAR": 80000
   },
   "COBRANZA_REPORTES": {
      "REPORTE_ESTADO_DE_CUENTA": 200000,
      "REPORTE_MOVIMIENTOS_CLIENTE": 200001,
      "REPORTE_COBRANZA_DETALLADA": 200002,
      "REPORTE_COBRANZA_GLOBAL": 200003,
      "REPORTE_DE_PAGOS_CREDITO": 200004,
      "REPORTE_DE_PAGOS_CONTADO": 200005,
      "REPORTE_DE_PAGOS_PENDIENTES": 200006,
      "REPORTE_DIFERENCIA_DE_PAGOS": 200007,
      "REPORTE_RELACION_FACTURAS": 200008,
      "REPORTE_PARA_RUTAS": 200009,
      "REPORTE_FACTURAS_SAT_FALTANTES": 200010
   },
   "COBRANZA_SALDO_FACTURISTA": {
      "CONSULTAR_SALDO": 220002
   },
   "EMBARQUE": {
      "VER_TODAS_EMBARQUES": 3000,
      "VER_EMBARQUES_SUCURSAL_DEL_USUARIO": 3001,
      "VER_EMBARQUES_CREADOS_POR_EL_USUARIO": 3002,
      "EDITAR_TODAS_EMBARQUES": 3003,
      "EDITAR_EMBARQUES_SUCURSAL_DEL_USUARIO": 3004,
      "EDITAR_EMBARQUES_CREADAS_POR_EL_USUARIO": 3005,
      "MARCAR_SALIDA_A_TODOS_LOS_EMBARQUES": 3007,
      "MARCAR_SALIDA_A_EMBARQUES_CREADOS_POR_EL_USUARIO": 3008,
      "MARCAR_SALIDA_A_EMBARQUES_DE_SUCURSAL_DEL_USUARIO": 3009,
      "MARCAR_LLEGADA_A_TODOS_LOS_EMBARQUES": 3010,
      "MARCAR_LLEGADA_A_EMBARQUES_CREADOS_POR_EL_USUARIO": 3011,
      "MARCAR_LLEGADA_A_EMBARQUES_DE_SUCURSAL_DEL_USUARIO": 3012,
      "DESCARGAR_REPORTE_PDF": 3013,
      "DESCARGAR_REPORTE_DE_TRAFICO": 3014,
      "DESCARGAR_REPORTE_DE_EMBARQUE_X_RUTA": 3015,
      "DESCARGAR_REPORTE_DE_ETIQUETAS_Y_GUIAS": 3016,
      "DESCARGAR_REPORTE_DE_ETIQUETAS_EMBARQUE_DESEMBARQUE": 3017,
      "EDITAR_EMBARQUE_SIN_RESTRICCIONES": 3018,
      "MARCAR_RETRASO_DE_EMBARQUE": 3019,
      "GENERAR_CARTA_PORTE_DEL_EMBARQUE": 3020,
      "CREAR_EMBARQUE": 3021,
      "DESCARGAR_REPORTE_PRODUCTOS": 3022,
      "DESEMBARQUE_GUIAS": 3023,
      "AGREGAR_REMOLQUE": 3024,
      "ELIMINAR_REMOLQUE": 3025,
      "ELIMINAR_CUALQUIER_GUIA_EMBARQUE": 3026,
      "ELIMINAR_GUIA_EMBARQUE_SUCURSAL_USUARIO": 3027,
      "AGREGAR_GUIAS_AL_EMBARQUE": 3028,
      "AGREGAR_GUIAS_RESTRICCION_SUCURSAL": 3029,
      "EMBARQUE_ADMINISTRATIVO": 3030,
   },
   "ENVIO_GUIAS_CYC": {
      "VER_TODOS_LOS_FOLIOS": 7000,
      "VER_FOLIOS_SUCURSAL_DEL_USUARIO": 7001,
      "VER_FOLIOS_CREADOS_POR_EL_USUARIO": 7002,
      "RECIBIR_FOLIO": 7003,
      "CERRAR_FOLIO": 7004,
      "DESCARGAR_REPORTE": 7005,
      "CREAR_FOLIO": 7005
   },
   "ESCANEO_EVIDENCIAS": {
      "ESCANEAR_EVICENCIAS": 9000
   },
   "GUIA": {
      "VER_TODAS_GUIAS": 2000,
      "VER_GUIAS_SUCURSAL_DEL_USUARIO": 2001,
      "VER_GUIAS_CREADAS_POR_EL_USUARIO": 2002,
      "EDITAR_TODAS_GUIAS": 2003,
      "EDITAR_GUIAS_SUCURSAL_DEL_USUARIO": 2004,
      "EDITAR_GUIAS_CREADAS_POR_EL_USUARIO": 2005,
      "EDITAR_GUIAS_SIN_RESTRICCIONES": 2006,
      "CANCELAR_TODAS_GUIAS": 2007,
      "CANCELAR_GUIAS_DE_SUCURSAL_DEL_USUARIO": 2008,
      "CANCELAR_GUIAS_CREADAS_POR_EL_USUARIO": 2009,
      "CANCELAR_SIN_RESTRICCIONES": 2010,
      "IMPRIMIR": 2011,
      "IMPRIMIR_CON_PRECIOS": 2012,
      "VER_HISTORIAL": 2013,
      "REDOCUMENTAR": 2014,
      "IMPRIMIR_ETIQUETAS": 2015,
      "REENVIAR_EMAIL": 2016,
      "ARCHIVO_CONCORD": 2017,
      "ARCHIVO_FLEXI": 2018,
      "ARCHIVO_ULINE": 2019,
      "ARCHIVO_URREA_VALVULAS": 2020,
      "ARCHIVO_PRODUCTOS_ULINE": 2021,
      "ARCHIVO_PRODUCTOS_3M": 2022,
      "REVISION_DE_EVIDENCIA": 2023,
      "ESCANEO_DE_EVIDENCIA": 2024,
      "SEGUIMIENTO_DE_GUIAS": 2025,
      "SEGUIMIENTO_DE_ETIQUETAS_DE_GUIAS": 2026,
      "CREAR_GUIAS": 2027,
      "CREAR_GUIAS_CLIENTE_USUARIO": 2028,
      "VER_GUIAS_CLIENTE_DEL_USUARIO": 2029,
      "EDITAR_GUIAS_CLIENTE_DEL_USUARIO": 2030,
      "AGREGAR_MANIFIESTOS": 2031,
   },
   "GUIAS_PENDIENTES_CYC": {
      "VER_TODAS_LAS_GUIAS": 6000,
      "VER_GUIAS_SUCURSAL_DEL_USUARIO": 6001,
      "VER_GUIAS_CREADAS_POR_EL_USUARIO": 6002,
      "APROVAR_GUIA": 6003
   },
   "IMPRESION_MULTIPLE_GUIAS": {
      "IMPRIMIR_GUIAS": 11000
   },
   "MARCAR_ENTREGAS": {
      "VER_TODAS_LAS_GUIAS_PENDIENTES_DE_ENTREGA": 5000,
      "VER_GUIAS_PENDIENTES_DE_ENTREGA_SUCURSAL_DEL_USUARIO": 5001,
      "VER_GUIAS_PENDIENTES_DE_ENTREGA_CREADAS_POR_EL_USUARIO": 5002,
      "MARCAR_GUIA_COMO_NO_ENTREGADA": 5003
   },
   "PREGUIA": {
      "VER_TODAS_PREGUIAS": 1000,
      "VER_PREGUIAS_SUCURSAL_DEL_USUARIO": 1001,
      "VER_PREGUIAS_CREADAS_POR_EL_USUARIO": 1002,
      "EDITAR_TODAS_PREGUIAS": 1003,
      "EDITAR_PREGUIAS_SUCURSAL_DEL_USUARIO": 1004,
      "EDITAR_PREGUIAS_CREADAS_POR_EL_USUARIO": 1005,
      "CANCELAR_TODAS_PREGUIAS": 1006,
      "CANCELAR_PREGUIAS_DE_SUCURSAL_DEL_USUARIO": 1007,
      "CANCELAR_PREGUIAS_CREADAS_POR_EL_USUARIO": 1008,
      "ASIGNAR_A_TRASNPORTISTA": 1009,
      "CONFIRMAR_RECOLECCION": 1010,
      "CONFIRMAR_ENTRADA_EN_SUSURSAL": 1011,
      "VER_HISTORIAL_DE_LA_PREGUIA": 1012,
      "AUTORIZAR_PREGUIA": 1013,
      "IMPRIMIR_PREGUIA": 1014,
      "CAMBIAR_DETALLES_DE_CARGA": 1015,
      "CARTA_PORTE_PREGUIA": 1016,
      "REPORTE_ASIGNADAS_A_TRANSPORTISTA": 1017,
      "REPORTE_REALIZADAS_POR_TRANSPORTISTA": 1018,
      "REPORTE_EFECTUADAS_PENDIENTES_DE_DOCUMENTAR": 1019,
      "REPORTE_DOCUMENTADAS": 1020,
      "REPORTE_TODAS_LAS_RECOLECCIONES": 1021,
      "REPORTE_CONFIRMADAS_POR_TRANSPORTISTA": 1022,
      "REPORTE_NO_CONFIRMADAS_POR_TRANSPORTISTA": 1023,
      "CREAR_PREGUIA": 1024
   },
   "REVISION_EVIDENCIAS": {
      "VER_EVIDENCIAS": 8000,
      "DESCARGAR_REPORTE": 8001,
      "REEMPLAZAR_EVIDENCIA": 8002,
      "CALIFICAR_EVIDENCIA": 8003
   },
   "SEGUIMIENTO_DE_GUIA": {
      "VER_TODAS_GUIAS": 10000,
      "VER_GUIAS_SUCURSAL_DEL_USUARIO": 10001,
      "VER_GUIAS_CREADAS_POR_EL_USUARIO": 10002,
      "CREAR_SEGUIMIENTO": 10003
   },
   "SEGUIMIENTO_ETIQUETAS": {
      "VER_TODAS_ETIQUETAS": 12000,
      "VER_ETIQUETAS_SUCURSAL_DEL_USUARIO": 12001,
      "VER_ETIQUETAS_CREADAS_POR_EL_USUARIO": 12002
   },
   "VENTAS_CALCULAR_KM": {
      "CALCULAR_KM": 13000
   },
   "VENTAS_COTIZACIONES": {
      "VER_TODAS_COTIZACIONES": 14000,
      "VER_COTIZACIONES_SUCURSAL_DEL_USUARIO": 14001,
      "VER_COTIZACIONES_CREADAS_POR_EL_USUARIO": 14002,
      "CREAR_COTIZACION": 14003
   },
   "VENTAS_FACTURA_ULINE": {
      "CREAR_FACTURA_ULINE": 19000
   },
   "VENTAS_FACTURAS_CONTADO": {
      "VER_TODAS_FACTURAS": 15000,
      "VER_FACTURAS_SUCURSAL_DEL_USUARIO": 15001,
      "VER_FACTURAS_CREADAS_POR_EL_USUARIO": 15002,
      "CREAR_FACTURA": 15003,
      "RE_ENVIAR_CORREO": 15004,
      "CANCELAR_FACTURA": 15005,
      "VER_PDF": 15006
   },
   "VENTAS_FACTURAS_CREDITO": {
      "VER_TODAS_FACTURAS": 16000,
      "VER_FACTURAS_SUCURSAL_DEL_USUARIO": 16001,
      "VER_FACTURAS_CREADAS_POR_EL_USUARIO": 16002,
      "CREAR_FACTURA": 16003,
      "RE_ENVIAR_CORREO": 16004,
      "CANCELAR_FACTURA": 16005,
      "VER_PDF": 16006
   },
   "VENTAS_MULTIPLE_CANCELACION": {
      "VER_CANCELACIONES": 18000,
      "LIBERAR_PROCESO": 18001
   },
   "VENTAS_REFACTURACION": {
      "VER_TODAS_FACTURAS": 17000,
      "VER_FACTURAS_SUCURSAL_DEL_USUARIO": 17001,
      "VER_FACTURAS_CREADAS_POR_EL_USUARIO": 17002,
      "CREAR_REFACTURACION": 17003
   },
   "VENTAS_REPORTES": {
      "REPORTE_CORTE": 20000,
      "REPORTE_VENTAS": 20001,
      "REPORTE_ANEXO_CORTE_POR_REDOCUMENTACION": 20002,
      "REPORTE_GUIAS_REDOCUMENTADAS": 20003,
      "REPORTE_VENTAS_POR_CONCEPTO": 20004,
      "REPORTE_CONTRA_RECIBOS": 20005,
      "REPORTE_GUIAS_RECIBIDAS_EN_FACTURACION": 20006,
      "REPORTE_VENTAS_POR_CLIENTE": 20007,
      "REPORTE_MANIFIESTOS": 20008,
      "REPORTE_CONTABILIDAD": 20009,
      "REPORTE_COMPLETOS": 20010,
      "REPORTE_GUIAS_PAGOS": 20011,
      "REPORTE_VENTAS_EAD": 20012,
   },
   "DIGITALIZAR": {
      "VER_DIGITALIZACIONES": 900,
      "DESCARGAR_EVIDENCIA": 901,
      "ELIMINAR_EVIDENCIA": 902,
      "ESCANEAR": 903,
      "REPORTE": 904,
   },
   "LISTA_PRECIOS": {
      "VER_LISTA_PRECIOS": 800,
      "EDITAR_LISTA_PRECIO": 801,
      "CREAR_LISTA_PRECIO": 802,
   },
   "CITAS_EAD": {
      "VER_TODAS": 1200,
      "VER_TODAS_SUCURSAL": 1210,
      "VER_TODAS_USUARIO": 1220,
      "VER_TODAS_CLIENTE": 1220,
      "VER_HISTORIAL": 1300,
      "MARCAR_INCUMPLIDA": 1310,
      "MARCAR_CANCELADA": 1320,
      "EDITAR_CITAS_TODAS": 1330,
      "EDITAR_CITAS_SUCURSAL": 1340,
      "EDITAR_CITAS_USUARIO": 1350,
      "EDITAR_CITAS_CLIENTE": 1360,
   },
   "INCIDENCIAS_MANIFIESTOS": {
      "VER_INCIDENCIAS": 550000,
      "CONFIRMAR_ENTERADO": 550001,
   }
};

const SUCURSAL_ACCESS = [
   /*PREGUIA*/ACCESS.PREGUIA.VER_PREGUIAS_SUCURSAL_DEL_USUARIO, ACCESS.PREGUIA.EDITAR_PREGUIAS_SUCURSAL_DEL_USUARIO, ACCESS.PREGUIA.CANCELAR_PREGUIAS_DE_SUCURSAL_DEL_USUARIO,
   /*GUIA*/ACCESS.GUIA.VER_GUIAS_SUCURSAL_DEL_USUARIO, ACCESS.GUIA.EDITAR_GUIAS_SUCURSAL_DEL_USUARIO, ACCESS.GUIA.CANCELAR_GUIAS_DE_SUCURSAL_DEL_USUARIO,
   /*EMBARQUE*/ACCESS.EMBARQUE.VER_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.EDITAR_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.MARCAR_SALIDA_A_EMBARQUES_DE_SUCURSAL_DEL_USUARIO,
   ACCESS.EMBARQUE.MARCAR_SALIDA_A_EMBARQUES_DE_SUCURSAL_DEL_USUARIO,
   /*ASIGNACION*/ACCESS.ASIGNACION_TRANSPORTISTA.MARCAR_SALIDA_A_ASIGNACIONES_DE_SUCURSAL_DEL_USUARIO, ACCESS.ASIGNACION_TRANSPORTISTA.EDITAR_ASIGNACIONES_SUCURSAL_DEL_USUARIO,
   ACCESS.ASIGNACION_TRANSPORTISTA.VER_ASIGNACIONES_SUCURSAL_DEL_USUARIO,
   /*MARCAR ENTREGAS*/ACCESS.MARCAR_ENTREGAS.VER_GUIAS_PENDIENTES_DE_ENTREGA_SUCURSAL_DEL_USUARIO,
   /*PENDIENTES CYC*/ACCESS.GUIAS_PENDIENTES_CYC.VER_GUIAS_SUCURSAL_DEL_USUARIO,
   /*ENVIO GUIAS CYC*/ACCESS.ENVIO_GUIAS_CYC.EDITAR_GUIAS_SUCURSAL_DEL_USUARIO,
   /*SEGUIMIENTO*/ACCESS.SEGUIMIENTO_DE_GUIA.VER_GUIAS_SUCURSAL_DEL_USUARIO,
   /*SEGUIMIENTO ETIQUETA*/ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_SUCURSAL_DEL_USUARIO,
   /*VENTAS COTIZACIONES*/ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_SUCURSAL_DEL_USUARIO,
   /*VENTAS FACTURAS CONTADO*/ACCESS.VENTAS_FACTURAS_CONTADO.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
   /*VENTAS FACTURAS CREDITO*/ACCESS.VENTAS_FACTURAS_CREDITO.VER_FOLIOS_SUCURSAL_DEL_USUARIO,
   /*VENTAS REFACTURACION*/ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_SUCURSAL_DEL_USUARIO,
   /*GUIAS RECIBIDAS*/ACCESS.COBRANZA_GUIAS_RECIBIDAS.VER_FOLIOS_SUCURSAL_DEL_USUARIO,
   /*ENVIO FACTURAS*/ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_SUCURSAL_USUARIO,
   /*CITAS EAD*/ACCESS.CITAS_EAD.EDITAR_CITAS_SUCURSAL, ACCESS.CITAS_EAD.VER_TODAS_SUCURSAL
];

const USER_ACCESS = [
   /*PREGUIA*/ACCESS.PREGUIA.VER_PREGUIAS_CREADAS_POR_EL_USUARIO, ACCESS.PREGUIA.EDITAR_PREGUIAS_CREADAS_POR_EL_USUARIO, ACCESS.PREGUIA.CANCELAR_PREGUIAS_CREADAS_POR_EL_USUARIO,
   /*GUIA*/ACCESS.GUIA.VER_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.GUIA.EDITAR_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.GUIA.CANCELAR_GUIAS_CREADAS_POR_EL_USUARIO,
   /*EMBARQUE*/ACCESS.EMBARQUE.VER_EMBARQUES_CREADOS_POR_EL_USUARIO, ACCESS.EMBARQUE.EDITAR_EMBARQUES_CREADAS_POR_EL_USUARIO, ACCESS.EMBARQUE.MARCAR_SALIDA_A_EMBARQUES_CREADOS_POR_EL_USUARIO,
   ACCESS.EMBARQUE.MARCAR_LLEGADA_A_EMBARQUES_CREADOS_POR_EL_USUARIO,
   /*ASIGNACION*/ACCESS.ASIGNACION_TRANSPORTISTA.VER_ASIGNACIONES_CREADAS_POR_EL_USUARIO, ACCESS.ASIGNACION_TRANSPORTISTA.EDITAR_ASIGNACIONES_CREADAS_POR_EL_USUARIO,
   ACCESS.ASIGNACION_TRANSPORTISTA.MARCAR_SALIDA_A_ASIGNACIONES_CREADAS_POR_EL_USUARIO,
   /*MARCAR ENTREGA*/ACCESS.MARCAR_ENTREGAS.VER_GUIAS_PENDIENTES_DE_ENTREGA_CREADAS_POR_EL_USUARIO,
   /*PENDIENTES CYC*/ACCESS.GUIAS_PENDIENTES_CYC.VER_GUIAS_CREADAS_POR_EL_USUARIO,
   /*ENVIO GUIAS CYC*/ACCESS.ENVIO_GUIAS_CYC.VER_FOLIOS_CREADOS_POR_EL_USUARIO,
   /*SEGUIMINETO GUIA*/ACCESS.SEGUIMIENTO_DE_GUIA.VER_GUIAS_CREADAS_POR_EL_USUARIO,
   /*SEGUIMIENTO ETIQUETA*/ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_CREADAS_POR_EL_USUARIO,
   /*VENTAS COTIZACIONES*/ACCESS.VENTAS_COTIZACIONES.VER_COTIZACIONES_CREADAS_POR_EL_USUARIO,
   /*VENTAS FACTURAS CONTADO*/ACCESS.VENTAS_FACTURAS_CONTADO.VER_FACTURAS_CREADAS_POR_EL_USUARIO,
   /*VENTAS FACTURAS CREDITO*/ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_CREADAS_POR_EL_USUARIO,
   /*VENTAS REFACTURACION*/ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_CREADAS_POR_EL_USUARIO,
   /*COBRANZA CONTROL DEPOSITO*/ACCESS.COBRANZA_CONTROL_DEPOSITO.VER_DEPOSITOS_CREADOS_POR_EL_USUARIO,
   /*COBRANZA ENVIO FACTURAS*/ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_CREADOS_POR_USUARIO,
   /*COBRANZA NOTAS CREDITO*/ACCESS.COBRANZA_NOTA_CREDITO.VER_NOTAS_CREADAS_POR_EL_USUARIO,
   /*COBRANZA_FACTURAS_POR_CLIENTE*/ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.VER_FOLIOS_CREADOS_POR_USUARIO,
   /*CITAS EAD*/ACCESS.CITAS_EAD.EDITAR_CITAS_USUARIO, ACCESS.CITAS_EAD.VER_TODAS_USUARIO
];

const CLIENTE_ACCESS = [
   /*GUIA*/ACCESS.GUIA.CREAR_GUIAS_CLIENTE_USUARIO, ACCESS.GUIA.VER_GUIAS_CLIENTE_DEL_USUARIO, ACCESS.GUIA.EDITAR_GUIAS_CLIENTE_DEL_USUARIO,
   /*CITAS EAD*/ACCESS.CITAS_EAD.EDITAR_CITAS_CLIENTE, ACCESS.CITAS_EAD.VER_TODAS_CLIENTE
]

export default ACCESS;
export {
   SUCURSAL_ACCESS,
   USER_ACCESS,
   CLIENTE_ACCESS,
}